import React from 'react';
import { Shield, Lock, Trash2, FileCheck } from 'lucide-react';

const Privacy = () => {
  const principles = [
    {
      icon: Shield,
      text: 'Non-komersialisasi mahasiswa'
    },
    {
      icon: Lock,
      text: 'Data hanya aktif selama acara wisuda'
    },
    {
      icon: Trash2,
      text: 'Seluruh data diserahkan dan dihapus setelah acara'
    },
    {
      icon: FileCheck,
      text: 'Konten sepenuhnya di bawah kendali kampus'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-sage-100 rounded-full mb-4">
            <Shield className="w-5 h-5 text-sage-700" />
            <span className="text-sm font-semibold text-sage-700 uppercase tracking-wide">Privasi & Etika</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Komitmen Privasi & Etika
          </h2>
          <p className="text-xl text-gray-700">
            Wisuda.ai dikembangkan dengan prinsip:
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {principles.map((principle, index) => (
            <div 
              key={index}
              className="flex items-center gap-4 p-6 bg-gradient-to-br from-sage-50 to-cream-50 rounded-xl border-2 border-sage-200 hover:border-sage-400 transition-all duration-300"
            >
              <div className="p-3 bg-white rounded-lg shadow-sm">
                <principle.icon className="w-6 h-6 text-sage-600" />
              </div>
              <p className="text-lg text-gray-800 font-medium">
                {principle.text}
              </p>
            </div>
          ))}
        </div>
        
        <div className="p-8 bg-gradient-to-r from-sage-100 to-terracotta-100 rounded-2xl border-2 border-sage-200 text-center">
          <p className="text-xl text-gray-900 font-semibold">
            Privasi, etika akademik, dan reputasi institusi adalah prioritas utama.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
